const Routes = {
  LOGIN: { URL: "/login" },
  HOME: { URL: "/onboarding/", showSidemenu: true },
  SEARCH: { URL: "/search", showSidemenu: true },
  THANKYOU: { URL: "/thank-you", showSidemenu: true },
  LANDING_PAGE: { URL: "/" },
};

export default Routes;
